import { useEffect } from 'react';

import { CompleteSetupGate } from '@/features/auth/components/CompleteSetupGate';
import { useAuth } from '@/lib/auth/AuthContext';
import { useInactivityLogout } from '@/lib/auth/useInactivityLogout';

import { ConsoleLayout } from './ConsoleLayout';
import { FullPageLoader } from './FullPageLoader';
import { SignInPrompt } from './SignInPrompt';

/**
 * Auth guard wrapping the ConsoleLayout. Three states :
 * - loading → spinner full-page
 * - error → SignIn prompt (lets user retry without infinite redirect loop)
 * - unauthenticated → trigger OIDC signin redirect automatically
 * - authenticated → render the shell
 */
export function ProtectedShell() {
    const { user, isAuthenticated, isLoading, error, signIn, signOut } = useAuth();

    useInactivityLogout(signOut);

    useEffect(() => {
        if (!isLoading && !isAuthenticated && !error) {
            signIn();
        }
    }, [isAuthenticated, isLoading, error, signIn]);

    if (isLoading) return <FullPageLoader />;
    if (error) return <SignInPrompt error={error} />;
    if (!isAuthenticated) return <FullPageLoader />;
    if (user && !user.partnerId) return <CompleteSetupGate />;

    return <ConsoleLayout />;
}
